export default __webpack_public_path__ + "img/slideshow/fac/3.png";